import { render, staticRenderFns } from "./KosmoForm.vue?vue&type=template&id=311a4e9e"
import script from "./KosmoForm.vue?vue&type=script&lang=js"
export * from "./KosmoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports